import { compatWrapper } from '@backstage/core-compat-api';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const componentFilter = (entity: { kind: string }) =>
  entity.kind.toLocaleLowerCase('en-US') === 'component';

export const anderTestReportsContent = EntityContentBlueprint.make({
  name: 'tests',
  params: {
    path: 'tests',
    title: 'Tests',
    filter: componentFilter,
    loader: async () =>
      import('./AnderTestReportsContent').then(module =>
        compatWrapper(<module.AnderTestReportsContent />),
      ),
  },
});

export const anderTestReportsModule = createFrontendPlugin({
  pluginId: 'ander-test-reports',
  extensions: [anderTestReportsContent],
});
